export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                汗汗漫画
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              汗汗漫画🎯汇聚漫画全集免费漫画大全资源，支持全集免费阅读，在线看漫画海量免费内容随时追更，轻松收藏。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-100 text-sm mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '读者热评', href: '#comments' },
                { label: '精选推荐', href: '#cards' },
                { label: '热门排行', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
                { label: '最新动态', href: '#updates' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-100 text-sm mb-4">热门分类</h4>
            <nav className="flex flex-col gap-2">
              {['热血战斗', '玄幻修真', '恋爱甜宠', '悬疑推理', '搞笑日常'].map((cat) => (
                <a
                  key={cat}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); handleNavClick('#index'); }}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                >
                  {cat}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-100 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴持续加入中，敬请期待。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 汗汗漫画 - 漫画全集免费漫画大全 | 全集免费阅读一次性看过瘾 | 在线看漫画海量资源免费看
          </p>
          <div className="flex items-center gap-6">
            <a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('#about'); }} className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">关于我们</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); handleNavClick('#faq'); }} className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">常见问题</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }} className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}